export default [
  {
    path: 'login',
    name: 'Login',
    component: () => import('./Login.vue'),
  },
]
